export enum SignMdaDialogLabels {
  WhoSign = 'Who is signing the Master Dealer Agreement',
  AgreeWithMda = 'Agree With Mda',
}
